var map = {
	"./png/ass.png": "./assets/stickers/png/ass.png",
	"./png/bed.png": "./assets/stickers/png/bed.png",
	"./png/cocktail.png": "./assets/stickers/png/cocktail.png",
	"./png/dirty.png": "./assets/stickers/png/dirty.png",
	"./png/doggy.png": "./assets/stickers/png/doggy.png",
	"./png/dynamite.png": "./assets/stickers/png/dynamite.png",
	"./png/grab.png": "./assets/stickers/png/grab.png",
	"./png/handcuffs.png": "./assets/stickers/png/handcuffs.png",
	"./png/heart.png": "./assets/stickers/png/heart.png",
	"./png/heartbroken.png": "./assets/stickers/png/heartbroken.png",
	"./png/hey.png": "./assets/stickers/png/hey.png",
	"./png/home_alone.png": "./assets/stickers/png/home_alone.png",
	"./png/hot.png": "./assets/stickers/png/hot.png",
	"./png/kiss.png": "./assets/stickers/png/kiss.png",
	"./png/man_easy.png": "./assets/stickers/png/man_easy.png",
	"./png/man_horny.png": "./assets/stickers/png/man_horny.png",
	"./png/man_naked.png": "./assets/stickers/png/man_naked.png",
	"./png/man_nudes.png": "./assets/stickers/png/man_nudes.png",
	"./png/man_play.png": "./assets/stickers/png/man_play.png",
	"./png/man_sex.png": "./assets/stickers/png/man_sex.png",
	"./png/man_spank.png": "./assets/stickers/png/man_spank.png",
	"./png/man_tattoos.png": "./assets/stickers/png/man_tattoos.png",
	"./png/nudes.png": "./assets/stickers/png/nudes.png",
	"./png/omg.png": "./assets/stickers/png/omg.png",
	"./png/photo.png": "./assets/stickers/png/photo.png",
	"./png/tease.png": "./assets/stickers/png/tease.png",
	"./png/wink.png": "./assets/stickers/png/wink.png",
	"./png/woman_gog.png": "./assets/stickers/png/woman_gog.png",
	"./png/woman_horny.png": "./assets/stickers/png/woman_horny.png",
	"./png/woman_naked.png": "./assets/stickers/png/woman_naked.png",
	"./png/woman_tattoos.png": "./assets/stickers/png/woman_tattoos.png",
	"./png/yeah.png": "./assets/stickers/png/yeah.png",
	"./svg/alone.svg": "./assets/stickers/svg/alone.svg",
	"./svg/ass.svg": "./assets/stickers/svg/ass.svg",
	"./svg/bed.svg": "./assets/stickers/svg/bed.svg",
	"./svg/cocktail.svg": "./assets/stickers/svg/cocktail.svg",
	"./svg/dirty.svg": "./assets/stickers/svg/dirty.svg",
	"./svg/doggy.svg": "./assets/stickers/svg/doggy.svg",
	"./svg/dynamite.svg": "./assets/stickers/svg/dynamite.svg",
	"./svg/grab.svg": "./assets/stickers/svg/grab.svg",
	"./svg/handcuffs.svg": "./assets/stickers/svg/handcuffs.svg",
	"./svg/heart.svg": "./assets/stickers/svg/heart.svg",
	"./svg/heartbroken.svg": "./assets/stickers/svg/heartbroken.svg",
	"./svg/hey.svg": "./assets/stickers/svg/hey.svg",
	"./svg/hot.svg": "./assets/stickers/svg/hot.svg",
	"./svg/kiss.svg": "./assets/stickers/svg/kiss.svg",
	"./svg/man_easy.svg": "./assets/stickers/svg/man_easy.svg",
	"./svg/man_horny.svg": "./assets/stickers/svg/man_horny.svg",
	"./svg/man_naked.svg": "./assets/stickers/svg/man_naked.svg",
	"./svg/man_nudes.svg": "./assets/stickers/svg/man_nudes.svg",
	"./svg/man_play.svg": "./assets/stickers/svg/man_play.svg",
	"./svg/man_sex.svg": "./assets/stickers/svg/man_sex.svg",
	"./svg/man_spank.svg": "./assets/stickers/svg/man_spank.svg",
	"./svg/man_tattoos.svg": "./assets/stickers/svg/man_tattoos.svg",
	"./svg/nudes.svg": "./assets/stickers/svg/nudes.svg",
	"./svg/omg.svg": "./assets/stickers/svg/omg.svg",
	"./svg/photo.svg": "./assets/stickers/svg/photo.svg",
	"./svg/tease.svg": "./assets/stickers/svg/tease.svg",
	"./svg/wink.svg": "./assets/stickers/svg/wink.svg",
	"./svg/woman_gog.svg": "./assets/stickers/svg/woman_gog.svg",
	"./svg/woman_horny.svg": "./assets/stickers/svg/woman_horny.svg",
	"./svg/woman_naked.svg": "./assets/stickers/svg/woman_naked.svg",
	"./svg/woman_tattoos.svg": "./assets/stickers/svg/woman_tattoos.svg",
	"./svg/yeah.svg": "./assets/stickers/svg/yeah.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/stickers sync recursive ^\\.\\/.*$";